import { render, staticRenderFns } from "./yinsi.vue?vue&type=template&id=1dde3494&scoped=true"
import script from "./yinsi.vue?vue&type=script&lang=js"
export * from "./yinsi.vue?vue&type=script&lang=js"
import style0 from "./yinsi.vue?vue&type=style&index=0&id=1dde3494&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dde3494",
  null
  
)

export default component.exports